import { render, staticRenderFns } from "./DTLogin.vue?vue&type=template&id=c5649ddc&scoped=true"
import script from "./DTLogin.vue?vue&type=script&lang=js"
export * from "./DTLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5649ddc",
  null
  
)

export default component.exports